import React from 'react'
import { Grid } from '@material-ui/core'

import ClientContext from 'contexts/ClientContext'
import ClientData from '../ClientData'
import ClientAddress from '../ClientAddress'

export default function Summary() {
  const { data } = React.useContext(ClientContext)
  return (
    <Grid container spacing={4}>
      <Grid item xs={12} md={6}>
        <ClientData data={data} />
      </Grid>
      <Grid item xs={12} md={6}>
        <ClientAddress address={data.addressAttributes} />
      </Grid>
    </Grid>
  )
}
